import { useEffect } from "react";

import "vanilla-cookieconsent";
import "vanilla-cookieconsent/dist/cookieconsent.css";
import { getUrl } from "../../utils/helper";

export default function Cookies({ locale = "en" }) {
    useEffect(() => {
        if (!document.getElementById("cc--main")) {
            window.CookieConsentApi = window.initCookieConsent();
            window.CookieConsentApi.run({
                current_lang: locale,
                gui_options: {
                    consent_modal: {
                        layout: "box",
                        position: "bottom left",
                    },
                },
                languages: {
                    en: {
                        consent_modal: {
                            title: "We use cookies!",
                            description:
                                'Hi, this website uses essential cookies to ensure its proper operation and tracking cookies to understand how you interact with it. The latter will be set only after consent. <button type="button" data-cc="c-settings" class="cc-link">Let me choose</button>',
                            primary_btn: {
                                text: "Accept all",
                                role: "accept_all", // 'accept_selected' or 'accept_all'
                            },
                            secondary_btn: {
                                text: "Reject all",
                                role: "accept_necessary", // 'settings' or 'accept_necessary'
                            },
                        },
                        settings_modal: {
                            title: "Cookie Preferences",
                            save_settings_btn: "Save settings",
                            accept_all_btn: "Accept all",
                            reject_all_btn: "Reject all",
                            close_btn_label: "Close",
                            cookie_table_headers: [
                                { col1: "Name" },
                                { col2: "Domain" },
                                { col3: "Expiration" },
                                { col4: "Description" },
                            ],
                            blocks: [
                                {
                                    title: "Cookie usage",
                                    description:
                                        'We use cookies to ensure the basic functionalities of the website and to enhance your online experience. You can choose for each category to opt-in/out whenever you want. For more details relative to cookies and other sensitive data, please read the full <a href="' +
                                        getUrl("privacy") +
                                        '" class="cc-link">privacy policy</a>.',
                                },
                                {
                                    title: "Strictly necessary cookies",
                                    description:
                                        "These cookies are essential for the proper functioning of this website. Without these cookies, the website would not work properly",
                                    toggle: {
                                        value: "necessary",
                                        enabled: true,
                                        readonly: true,
                                    },
                                },
                                {
                                    title: "Performance and Analytics cookies",
                                    description:
                                        "These cookies allow the website to remember the choices you have made in the past",
                                    toggle: {
                                        value: "analytics", // your cookie category
                                        enabled: false,
                                        readonly: false,
                                    },
                                    cookie_table: [
                                        // list of all expected cookies
                                        {
                                            col1: "^_ga", // match all cookies starting with "_ga"
                                            col2: "google.com",
                                            col3: "2 years",
                                            col4: "This cookie collects information about how users use this website, for analytical purposes.",
                                            is_regex: true,
                                        },
                                        {
                                            col1: "_gid",
                                            col2: "google.com",
                                            col3: "1 day",
                                            col4: "This cookie collects information about how users use this website, for analytical purposes.",
                                        },
                                    ],
                                },
                                {
                                    title: "Advertisement and Targeting cookies",
                                    description:
                                        "These cookies collect information about how you use the website, which pages you visited and which links you clicked on. All of the data is anonymized and cannot be used to identify you",
                                    toggle: {
                                        value: "targeting",
                                        enabled: false,
                                        readonly: false,
                                    },
                                },
                                {
                                    title: "More information",
                                    description:
                                        'For any queries in relation to our policy on cookies and your choices, please <a class="cc-link" href="' +
                                        getUrl("contacts") +
                                        '">contact us</a>.',
                                },
                            ],
                        },
                    },
                    pt: {
                        consent_modal: {
                            title: "Este site usa cookies!",
                            description:
                                'Olá, este website usa cookies essenciais para garantir o funcionamento adequado e cookies de rastreamento para entender como interage com ele. Estes últimos serão aplicados somente após o seu consentimento. <button type="button" data-cc="c-settings" class="cc-link">Definições de cookies</button>',
                            primary_btn: {
                                text: "Aceitar todos",
                                role: "accept_all", // 'accept_selected' or 'accept_all'
                            },
                            secondary_btn: {
                                text: "Rejeitar todos",
                                role: "accept_necessary", // 'settings' or 'accept_necessary'
                            },
                        },
                        settings_modal: {
                            title: "Preferências de Cookies",
                            save_settings_btn: "Guardar escolha",
                            accept_all_btn: "Aceitar todos",
                            reject_all_btn: "Rejeitar todos",
                            close_btn_label: "Fechar",
                            cookie_table_headers: [
                                { col1: "Nome" },
                                { col2: "Domínio" },
                                { col3: "Validade" },
                                { col4: "Detalhes" },
                            ],
                            blocks: [
                                {
                                    title: "Uso de cookies",
                                    description:
                                        'Este site utiliza cookies para garantir o bom funcionamento de funções básicas e para melhorar a sua experiência de utilização. Pode ativar ou desativar as cookies que desejar em cada categoria. Para mais detalhes relativos a cookies ou outra informação mais sensível, por favor leia a nossa <a href="' +
                                        getUrl("privacy") +
                                        '" class="cc-link">política de privacidade</a>.',
                                },
                                {
                                    title: "Cookies essenciais",
                                    description:
                                        "Estes cookies são essenciais para o correcto funcionamento do site.",
                                    toggle: {
                                        value: "necessary",
                                        enabled: true,
                                        readonly: true,
                                    },
                                },
                                {
                                    title: "Cookies de desempenho e analíticos",
                                    description:
                                        "Estes cookies recolhem informações sobre como utiliza o site, as páginas que visitou e os links em que clicou. Todos os dados são anónimos e não podem ser usados para o identificar.",
                                    toggle: {
                                        value: "analytics", // your cookie category
                                        enabled: false,
                                        readonly: false,
                                    },
                                    cookie_table: [
                                        // list of all expected cookies
                                        {
                                            col1: "^_ga", // match all cookies starting with "_ga"
                                            col2: "google.com",
                                            col3: "2 anos",
                                            col4: "Este cookie recolhe informação sobre como os utilizadores usam este website, para efeitos analíticos.",
                                            is_regex: true,
                                        },
                                        {
                                            col1: "_gid",
                                            col2: "google.com",
                                            col3: "1 dia",
                                            col4: "Este cookie recolhe informação sobre como os utilizadores usam este website, para efeitos analíticos.",
                                        },
                                    ],
                                },
                                {
                                    title: "Cookies de publicidade e segmentação",
                                    description:
                                        "Estes cookies recolhem informações do utilizador e usam-as para criar um perfil dos interesses do visitante e, em seguida, exibir anúncios personalizados para esse utilizador específico.",
                                    toggle: {
                                        value: "targeting",
                                        enabled: false,
                                        readonly: false,
                                    },
                                },
                                {
                                    title: "Mais informações",
                                    description:
                                        'Para esclarecimento de qualquer dúvida em relação à nossa política de cookies e às suas escolhas, por favor <a class="cc-link" href="' +
                                        getUrl("contacts") +
                                        '">contacte-nos</a>.',
                                },
                            ],
                        },
                    },
                },
            });
        }
    }, []);

    return null;
}
